import React, {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import api from "../../services/api";
import {auth} from "../../services/auth";

const handleTokenLogin = async (loginToken:any, navigate:any, viewId:any) => {
  try {
    const sessionData: any = await api.post('/sessions-with-token', { token: loginToken }, true);
    auth.setToken(sessionData.id);

    // ⬇️ Töröld csak a token paramétert, a többivel együtt megtartva
    const url = new URL(window.location.href);
    url.searchParams.delete('token');

    // navigate nem kell külön, csak az URL-t cseréljük (nincs új route)
    window.history.replaceState(null, '', url.toString());

    // ⬇️ Frissítés tiszta URL-lel
    window.location.reload();

  } catch (error) {
    console.error('Tokenes bejelentkezés sikertelen:', error);
  }
};

export const Layout = () => {

  const navigate = useNavigate();

  useEffect(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const loginToken = urlParams.get('token');
    const viewId = urlParams.get('view_id');

    if (loginToken) {
      handleTokenLogin(loginToken, navigate,viewId);
    }else{
      navigate('/login');
    }

  },[])

  return (
    <Box >
      <Outlet />
    </Box>
  );
};
